/**
 * @param {int} construpUserId
 * @param {int} integrationType
 */
export function buildRequiredIntegrationQueryParams(construpUserId, integrationType) {
  return new URLSearchParams({
    construpUserId,
    integrationType,
  }).toString();
}
